// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
const name = "atmosphereUboDeclaration";
const shader = `struct Atmosphere {peakRayleighScattering: vec3<f32>,
planetRadius: f32,
peakMieScattering: vec3<f32>,
atmosphereThickness: f32,
peakMieAbsorption: vec3<f32>,
planetRadiusSquared: f32,
peakMieExtinction: vec3<f32>,
atmosphereRadius: f32,
peakOzoneAbsorption: vec3<f32>,
atmosphereRadiusSquared: f32,
horizonDistanceToAtmosphereEdge: f32,
horizonDistanceToAtmosphereEdgeSquared: f32,
planetRadiusWithOffset: f32,
planetRadiusOffset: f32,
atmosphereExposure: f32,
aerialPerspectiveRadianceBias: f32,
inverseAtmosphereThickness: f32,
aerialPerspectiveTransmittanceScale: f32,
inverseViewProjectionWithoutTranslation: mat4x4<f32>,
directionToLight: vec3<f32>,
multiScatteringIntensity: f32,
directionToLightRelativeToCameraGeocentricNormal: vec3<f32>,
cameraRadius: f32,
lightRadianceAtCamera: vec3<f32>,
diffuseSkyIrradianceDesaturationFactor: f32,
groundAlbedo: vec3<f32>,
aerialPerspectiveSaturation: f32,
minMultiScattering: vec3<f32>,
diffuseSkyIrradianceIntensity: f32,
cameraPositionGlobal: vec3<f32>,
lightIntensity: f32,
clampedCameraPositionGlobal: vec3<f32>,
aerialPerspectiveIntensity: f32,
cameraGeocentricNormal: vec3<f32>,
clampedCameraRadius: f32,
cameraForward: vec3<f32>,
clampedCameraHeight: f32,
cameraPosition: vec3<f32>,
cosCameraHorizonAngleFromZenith: f32,
viewport: vec4<f32>,
additionalDiffuseSkyIrradiance: vec3<f32>,
cameraHeight: f32,
cameraNearPlane: f32,
originHeight: f32,
sinCameraAtmosphereHorizonAngleFromNadir: f32,
transmittanceSampleCount: f32,
skyViewLutSampleCount: f32,
multiScatteringLutSampleCount: f32,
multiScatteringAzimuthSampleCount: f32,
multiScatteringInclinationSampleCount: f32,
diffuseSkyIrradianceLutSampleCount: f32};var<uniform> atmosphere : Atmosphere;
`;
// Sideeffect
if (!ShaderStore.IncludesShadersStoreWGSL[name]) {
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
}
/** @internal */
export const atmosphereUboDeclarationWGSL = { name, shader };
